import { useCallback } from 'react';

import { api } from '@/api';
import { API_URL } from '@/dtos';

export default () => {
  const handleDownload = useCallback(async (id: string) => {
    const response = await api.get(API_URL.FILE_FILE_LINK_BY_FILE_ID(id));

    const url = response?.data?.url;
    const link = document.createElement('a');
    link.setAttribute('download', '');
    link.href = url || '';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }, []);

  return handleDownload;
};
